import { render } from "./SuperLikes.vue?vue&type=template&id=5d5c5c75&scoped=true"
import script from "./SuperLikes.vue?vue&type=script&lang=js"
export * from "./SuperLikes.vue?vue&type=script&lang=js"

import "./SuperLikes.vue?vue&type=style&index=0&id=5d5c5c75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5c5c75"]])

export default __exports__